/*globals $:false */

// `$container`: the jquery HTML wrapper for the enclosing element
//
// callbacks:
// * `filter(filterStr)`: only show Domains and Definitions that match the given filter
const DomainsDefinitionsFilterV = function(core, $container, callbacks) {

    const $filterInput = $(".js-filter-domains-defs", $container);

    const _init = function(filterStr) {
        $filterInput.on('input', $.debounce(function(){
            // eslint-disable-next-line no-invalid-this
            const filter = $(this).val();

            callbacks.filter(filter);
        }, 50));

        if(filterStr?.trim()?.length > 0){
            $filterInput.val(filterStr);
        }
    };

    const _focus = function(){
        $filterInput.focus();
    }

    const _destroy = function() {
        $filterInput.off();
    };

    return {
        init: _init,
        focus: _focus,
        destroy: _destroy
    }
};

export default DomainsDefinitionsFilterV;
